import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { TIMERS } from '../constants/timers';
import { USER_ACTIVITY_EVENTS } from '../constants/user-activity-events';
import { Paths } from '../routes/paths-enum';
import { LOCAL_STORAGE } from '../constants/local-storage';

export const useWatchUserActionsNoAuth = () => {
  const [lastUserActivityTime, setLastUserActivityTime] = useState(Date.now());
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const notifyCurrentAndOtherTabsUserWasActive = useCallback(() => {
    setLastUserActivityTime(Date.now());
  }, []);

  useEffect(() => {
    const isAuthorized = sessionStorage.getItem(LOCAL_STORAGE.isAuthorized);
    const inactivityInterval = setInterval(() => {
      const currentTime = Date.now();
      const timeDifference = currentTime - lastUserActivityTime;

      if (!isAuthorized && timeDifference > TIMERS.LAST_ACTIVE) {
        navigate(Paths.MAIN);
        clearInterval(inactivityInterval);
      }

      if (isAuthorized || pathname === Paths.MAIN) clearInterval(inactivityInterval);
    }, TIMERS.ONE_SECOND);

    USER_ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, notifyCurrentAndOtherTabsUserWasActive);
    });

    return () => {
      clearInterval(inactivityInterval);
      USER_ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, notifyCurrentAndOtherTabsUserWasActive);
      });
    };
  }, [lastUserActivityTime, notifyCurrentAndOtherTabsUserWasActive, navigate, pathname]);

  return { lastUserActivityTime };
};
